import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { LayoutGroup } from 'motion/react';
import { CarouselBarProps } from '../types';

export const CarouselBar = forwardRef<HTMLDivElement, CarouselBarProps>(
  ({ activeSlide, children, fullWidth, isScrollable, uniqueId, ...rest }, ref) => {
    return (
      <div ref={ref} css={carouselListStyles} data-role='carousellist' {...rest}>
        <LayoutGroup id={uniqueId}>{children}</LayoutGroup>
      </div>
    );
  }
);

const carouselListStyles = css({
  width: '100%',
  height: '40px',
  display: 'flex',
  overflow: 'auto hidden',
  position: 'relative',
  scrollbarWidth: 'none',
  scrollBehavior: 'smooth',
});

CarouselBar.displayName = 'CarouselBar';
